import { render, staticRenderFns } from "./horizontal-menu-linkage.vue?vue&type=template&id=022faa78&scoped=true&"
import script from "./horizontal-menu-linkage.vue?vue&type=script&lang=js&"
export * from "./horizontal-menu-linkage.vue?vue&type=script&lang=js&"
import style0 from "./horizontal-menu-linkage.vue?vue&type=style&index=0&id=022faa78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022faa78",
  null
  
)

export default component.exports